import { render } from "./SignOut.vue?vue&type=template&id=2ac71c32"
import script from "./SignOut.vue?vue&type=script&lang=js"
export * from "./SignOut.vue?vue&type=script&lang=js"
script.render = render

export default script